import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { FormattedMessage } from 'react-intl';
import styles from './feedback-question.css';
import { FeedbackHOC } from './questionHOC.jsx';
import closeIcon from '../menu-bar/icon--close.svg';

if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}

class Feedbackquestion extends React.Component {
    constructor() {
        super()
        this.mapquestions = this.mapquestions.bind(this)
        this.handleOpenUrl = this.handleOpenUrl.bind(this)
    }
    componentDidMount() {
    }
    mapquestions() {
        let lang = localStorage.getItem('language') || this.props.locales.locale
        let questions = this.props.question.list[lang] || this.props.question.list['en']
        return questions.filter((item) => {
            return item.show === true
        })
    }
    handleOpenUrl() {
        if (ipcRenderer) {
            ipcRenderer.send('openUrl', "https://www.yuque.com/zmrobo/robocode")
        } else {
            window.open('https://www.yuque.com/zmrobo/robocode')
        }
    }

    render() {
        const {
            className = "",
            handleShow,
            setQuestion,
            question
        } = this.props
        return (
            <div className={classnames(styles.Feedbackquestion, className.Feedbackquestion)}>
                <div className={styles.bg}></div>
                <div className={classnames(styles.questionContainer, className.questionContainer)}>
                    <div className={classnames(styles.navbar, className.navbar)}>
                        <h3><FormattedMessage
                            id="gui.feedback.problem"
                        /></h3>
                        {question.showquestion ? <div className={styles.closeBtn}>
                            <img src={closeIcon} alt="" onClick={() => { setQuestion(false) }} />
                        </div> : null}
                    </div>
                    <div className={styles.questionBox}>
                        <div className={styles.questionItem} onClick={this.handleOpenUrl}>
                            中鸣编程-帮助文档
                        </div>
                        {this.mapquestions().map((item, value) => {
                            return <div className={styles.questionItem} key={value} onClick={() => { handleShow(item) }}>{item.title}</div>
                        })}
                    </div>
                </div>
            </div>
        )
    }
}
const Feedbackquestions = FeedbackHOC(Feedbackquestion)

export default Feedbackquestions